import React from 'react';
import { Film } from 'lucide-react';

export default function CreativePreviewFallback({
  label = 'Preview not ready',
  compact = false,
  className = '',
}) {
  return (
    <div
      className={`flex h-full w-full items-center justify-center bg-[linear-gradient(135deg,rgba(15,23,42,1)_0%,rgba(30,41,59,0.96)_100%)] ${className}`}
    >
      <div className={`flex flex-col items-center justify-center text-center ${compact ? 'gap-1.5' : 'gap-3'}`}>
        <div className={`rounded-2xl border border-white/10 bg-white/5 text-white/70 shadow-[0_18px_45px_rgba(15,23,42,0.18)] ${compact ? 'p-2' : 'p-4'}`}>
          <Film className={compact ? 'h-4 w-4' : 'h-8 w-8'} strokeWidth={1.8} />
        </div>
        {!compact ? (
          <p className="text-[11px] font-medium uppercase tracking-[0.16em] text-white/58">
            {label}
          </p>
        ) : null}
      </div>
    </div>
  );
}
